import Api from './api';

const createBankingTransaction = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/banking/transaction/create', data, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const createMoneyOutTransaction = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/banking/money-out/create', data, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const editBankingTransaction = (data, id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/banking/transaction/edit/' + id, data, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const editRefundTransaction = (data, id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/banking/refund-transaction/edit/' + id, data, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const getTransactionTotals = (userId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/banking/transaction/totals/' + userId, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const getClientTransactionTotals = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/banking/client-transaction/totals/', {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const getTransaction = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/banking/transaction/edit/' + id, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const getRefundTransaction = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/banking/refund-transaction/edit/' + id, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const getAllTransactions = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/banking/transactions/all', query, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const paymentDepositInvoice = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/banking/invoice/deposit', data, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const deleteTransactionById = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/banking/transaction/delete/', data, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const downloadStatement = (dates) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/banking/statement/', dates, {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
    })
}
const downloadStatementSheet = (dates) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/banking/statement-sheet/', dates, {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
    })
}
const showStatement = (dates) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/banking/current-statement/', dates, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const fetchClientDeposits = (user) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/banking/client-deposits/' + user, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const fetchReceivables = (user) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/banking/receivables/' + user, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}
const fetchPaidAmounts = (inv) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/banking/inv-payment/' + inv, {
        headers: { Authorization: 'Bearer ' + access_token },
    });
}
const getClientUnpaidInvoices = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/banking/client-unpaid-invoices/', data, {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}

export default {
    editBankingTransaction,
    editRefundTransaction,
    createBankingTransaction,
    createMoneyOutTransaction,
    getAllTransactions,
    getTransactionTotals,
    getClientTransactionTotals,
    getTransaction,
    getRefundTransaction,
    paymentDepositInvoice,
    deleteTransactionById,
    downloadStatement,
    showStatement,
    fetchClientDeposits,
    fetchReceivables,
    getClientUnpaidInvoices,
    fetchPaidAmounts

}



// WEBPACK FOOTER //
// ./src/api/apiBankingTransactions.js